import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import type { AdminActionType } from '../../../api/types';
import { Card } from '../../../shared/ui/Card';
import { Field } from '../../../shared/ui/Field';
import { Input } from '../../../shared/ui/Input';
import { Select } from '../../../shared/ui/Select';
import styles from './AuditLogFilters.module.css';

const ACTION_TYPES: AdminActionType[] = [
  'USER_BLOCKED',
  'USER_UNBLOCKED',
  'SETTINGS_UPDATED',
  'ADMIN_CREATED',
  'ADMIN_DEACTIVATED',
  'ADMIN_REACTIVATED',
  // PARA-151, AC-8 (паттерн PARA-114, AC-5).
  'MFA_ENABLED',
  'MFA_DISABLED',
  'MFA_RESET',
];

// PARA-106, AC-9: фильтры синхронизированы с URL (useSearchParams) — раздел
// "Logs" становится шаримой ссылкой (см. story §2 обоснование роутинга).
export function AuditLogFilters(): JSX.Element {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const setParam = (key: string, value: string): void => {
    const next = new URLSearchParams(searchParams);
    if (value) {
      next.set(key, value);
    } else {
      next.delete(key);
    }
    setSearchParams(next);
  };

  return (
    <Card>
      <fieldset className={styles.filters}>
        <Field label={t('logs.filters.dateFrom')} htmlFor="date-from">
          <Input
            id="date-from"
            type="date"
            value={searchParams.get('date_from') ?? ''}
            onChange={(event) => setParam('date_from', event.target.value)}
          />
        </Field>
        <Field label={t('logs.filters.dateTo')} htmlFor="date-to">
          <Input
            id="date-to"
            type="date"
            value={searchParams.get('date_to') ?? ''}
            onChange={(event) => setParam('date_to', event.target.value)}
          />
        </Field>
        <Field label={t('logs.filters.adminId')} htmlFor="admin-id">
          <Input
            id="admin-id"
            type="number"
            value={searchParams.get('admin_id') ?? ''}
            onChange={(event) => setParam('admin_id', event.target.value)}
          />
        </Field>
        <Field label={t('logs.filters.actionType')} htmlFor="action-type">
          <Select
            id="action-type"
            value={searchParams.get('action_type') ?? ''}
            onChange={(event) => setParam('action_type', event.target.value)}
          >
            <option value="">—</option>
            {ACTION_TYPES.map((actionType) => (
              <option key={actionType} value={actionType}>
                {actionType}
              </option>
            ))}
          </Select>
        </Field>
      </fieldset>
    </Card>
  );
}
